import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[realNumberOnly]',
  standalone: true
})
export class RealNumberOnlyDirective {

  private regex = /[^0-9.]/g;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  @HostListener('input')
  onInput() {
    let value = this.el.nativeElement.value;

    // remove invalid chars
    value = value.replace(this.regex, '');

    // allow only one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    // update DOM (safe)
    this.el.nativeElement.value = value;

    // update Angular form properly (IMPORTANT)
    this.control.control?.setValue(value, { emitEvent: false });
  }
}